import { actulizarDatosenbasededatos, actulizarLogodeempresa, cambiarelestado_Empresa, crearNuevaEmpresa, editarDatosEmpresa, extraerDatosDeEmpresa, getBitacora_Empresa, insertartBitacora_Empresa, obtenerDetallesClientesEmpresa, traerTodasLasEmpresas } from "./Api_Empresa_Providers";

/**
 * Fetches the list of all companies from the API.
 *
 * @returns {Function} A thunk function that returns a Promise resolving with the list of companies.
 */
export const obtenerListaEmpresas = () => {
    return async () => {
        try {
            const resultado = await traerTodasLasEmpresas();
            return resultado.data["0"];
        } catch (error) {
            console.error("Error fetching the list of companies:", error);
        }
    };
};

/**
 * Fetches the details of a specific company by its ID.
 *
 * @param {number} idempresa - The ID of the company.
 * @returns {Function} A thunk function that returns a Promise resolving with the company details.
 */
export const getSpecificempresa = (idempresa) => {
    return async () => {
        try {
            const resultado = await extraerDatosDeEmpresa({ idempresa });
            return resultado.data["0"]["0"];
        } catch (error) {
            console.error("Error fetching company details:", error);
        }
    };
};

/**
 * Fetches the list of clients for a specific company by its ID.
 *
 * @param {number} idEmpresa - The ID of the company.
 * @returns {Function} A thunk function that returns a Promise resolving with the list of clients.
 */
export const obtenerListaClientesPorEmpresa = (idEmpresa) => {
    return async () => {
        try {
            const resultado = await obtenerDetallesClientesEmpresa({ idEmpresa });
            return resultado.data["0"];
        } catch (error) {
            console.error("Error fetching clients for the company:", error);
        }
    };
};

/**
 * Updates the logo of a specific company.
 *
 * @param {FormData} formData - The form data containing the logo and related information.
 * @returns {Function} A thunk function that dispatches actions based on the result of the operation.
 */
export const cambiarLogoEmpresa = (formData) => {
    return async (dispatch) => {
        try {
            const resultado = await actulizarLogodeempresa(formData);
            if (resultado.data.statusCode === 200) {
                const array = {
                    image: formData.get("image"),
                    imageName: formData.get("imageName"),
                    imageType: formData.get("imageType"),
                    token_access: formData.get("token_access"),
                    database: formData.get("database"),
                    sqlQuery: formData.get("sqlQuery"),
                    id_empresa: formData.get("id_empresa"),
                };
                await actulizarDatosenbasededatos({ array });
            }
            return resultado.data["0"];
        } catch (error) {
            console.error("Error updating company logo:", error);
            dispatch({
                type: "CAMBIAR_LOGO_EMPRESA_ERROR",
                payload: error,
            });
        }
    };
};

/**
 * Fetches the log entries (bitácora) for a specific company by its ID.
 *
 * @param {number} idempresa - The ID of the company.
 * @returns {Function} A thunk function that returns a Promise resolving with the log entries.
 */
export const getBitacoraEmpresa = (idempresa) => {
    return async () => {
        try {
            const resultado = await getBitacora_Empresa({ idempresa });
            return resultado.data["0"];
        } catch (error) {
            console.error("Error fetching company log entries:", error);
        }
    };
};

/**
 * Inserts a new log entry (bitácora) for a specific company.
 *
 * @param {string} nota - The note to be recorded in the log.
 * @param {Object} empresa - The company object.
 * @returns {Function} A thunk function that dispatches actions based on the result of the operation.
 */
export const insertartBitacoraEmpresa = (nota, empresa) => {
    return async (dispatch, getState) => {
        const { id_admin, name_admin } = getState().auth;
        try {
            const resultado = await insertartBitacora_Empresa({ nota, id_empresa: empresa, id_admin, name_admin });
            return resultado.data["0"];
        } catch (error) {
            console.error("Error inserting log entry for the company:", error);
        }
    };
};



/**
 * Creates a new company record and associates it with the current admin.
 *
 * @param {Object} empresaData - The data object containing information about the company to be created.
 * @returns {Function} A thunk function that, when invoked, attempts to create the new company record.
 *                      On success, it returns the result of the operation; on failure, logs an error.
 */
export const crearEmpresa = (empresaData) => {
    return async (dispatch, getState) => {
        // Extracts the admin ID and name from the current authentication state
        const { id_admin, name_admin } = getState().auth;

        try {
            // Calls the API function to create a new company entry with admin details
            const resultado = await crearNuevaEmpresa({ empresaData, id_admin, name_admin });


            // Returns the first item of the data response if successful
            return resultado.data["0"];
        } catch (error) {
            // Logs any errors that occur during the company creation process
            console.error("Error creating company record:", error);
        }
    };
};




/**
 * Edits an existing company record using the provided company data.
 *
 * @param {Object} empresaData - The data object containing updated information about the company.
 * @returns {Function} A thunk function that, when invoked, attempts to update the company record.
 *                      On success, it returns the updated company data; on failure, logs an error.
 */
export const editarEmpresa = (empresaData) => {
    return async () => {

        try {
            // Calls the API function to update the company data with the provided details
            const resultado = await editarDatosEmpresa({ empresaData });

            // Returns the first item of the response data if the update is successful
            return resultado.data["0"];
        } catch (error) {
            // Logs any errors that occur during the company update process
            console.error("Error updating company record:", error);
        }
    };
};



/**
 * Updates the status of an existing company using the provided company details and status.
 *
 * @param {Object} empresaDetails - The object containing the company's current details.
 * @param {string} status - The new status to update the company with.
 * @returns {Function} A thunk function that, when executed, updates the company's status via an API call.
 *                      On success, it returns the updated company data; on failure, it logs an error.
 */
export const cambiarelestadoEmpresa = (empresaDetails, status) => {
    return async () => {
        try {
            // Calls the API to update the company's status with the provided details and status
            const resultado = await cambiarelestado_Empresa({ empresaDetails, status });

            // Returns the updated company data (first item from the response)
            return resultado.data["0"];
        } catch (error) {
            // Logs any errors encountered during the update process
            console.error("Error updating the company status:", error);
        }
    };
};
